var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.hide_label
      ? _c(
          "label",
          {
            staticClass: "prop",
            class: { required: _vm.item.REQUIRED == "Y" },
            attrs: { for: "" },
          },
          [_vm._v(_vm._s(_vm.item.NAME))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.item.TYPE == "STRING" && _vm.item.MULTILINE !== "Y"
      ? _c("input", {
          class: { error: _vm.item.ERRORS.length > 0 },
          attrs: {
            type: "text",
            name: "ORDER_PROP_" + _vm.item.ID,
            placeholder: _vm.item.NAME,
            required: _vm.item.REQUIRED == "Y",
          },
          domProps: { value: _vm.setValue },
          on: {
            input: function ($event) {
              return _vm.rememberValue(_vm.item, $event)
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.item.ERRORS.length > 0
      ? _c(
          "div",
          { staticClass: "error-list" },
          _vm._l(_vm.item.ERRORS, function (error) {
            return _c("div", { staticClass: "error-one" }, [
              _vm._v(_vm._s(error)),
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hide_label && _vm.item.REQUIRED == "Y"
      ? _c("span", { staticClass: "requared" }, [_vm._v("\n    *\n  ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.item.TYPE == "STRING" && _vm.item.MULTILINE == "Y"
      ? _c("textarea", {
          class: { error: _vm.item.ERRORS.length > 0 },
          attrs: {
            type: "text",
            name: "ORDER_PROP_" + _vm.item.ID,
            placeholder: _vm.item.NAME,
            required: _vm.item.REQUIRED == "Y",
          },
          domProps: { value: _vm.setValue },
          on: {
            input: function ($event) {
              return _vm.rememberValue(_vm.item, $event)
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.dataAutocomplete.items.length > 0
      ? _c(
          "div",
          { staticClass: "autocomplete" },
          _vm._l(_vm.dataAutocomplete.items, function (item) {
            return _c(
              "div",
              {
                staticClass: "one-variant",
                on: {
                  click: function ($event) {
                    return _vm.pickLegalPerson(item)
                  },
                },
              },
              [_vm._v("\n            " + _vm._s(item.value_text) + "\n      ")]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }